// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"eee6297b","250":"c5281ad2"}[chunkId] + ".chunk.css";
};